import { useState, useEffect } from 'react';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem('careguard_pwa_dismissed');
    if (dismissed) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    if (result.outcome === 'accepted') {
      setShowPrompt(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('careguard_pwa_dismissed', 'true');
  };

  // iOS detection
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  const [showIOSTip, setShowIOSTip] = useState(false);

  useEffect(() => {
    if (isIOS && !isStandalone && !localStorage.getItem('careguard_pwa_dismissed')) {
      setTimeout(() => setShowIOSTip(true), 3000);
    }
  }, [isIOS, isStandalone]);

  if (!showPrompt && !showIOSTip) return null;

  return (
    <div style={{
      position: 'fixed', bottom: '80px', left: '50%', transform: 'translateX(-50%)',
      background: '#fff', borderRadius: '12px', padding: '1rem 1.25rem',
      boxShadow: '0 4px 24px rgba(0,0,0,0.15)', zIndex: 9998, maxWidth: '360px', width: '90%',
      border: '2px solid #2c5364'
    }} data-testid="install-prompt">
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
        <img src="/careguard-logo.png" alt="CareGuard" style={{ width: '40px', height: '40px', borderRadius: '8px' }} />
        <div>
          <div style={{ fontWeight: '700', color: '#2c5364', fontSize: '0.95rem' }}>Install CareGuard</div>
          <div style={{ fontSize: '0.8rem', color: '#6b8899' }}>Add to your home screen</div>
        </div>
      </div>

      {showIOSTip ? (
        <>
          <p style={{ margin: '0 0 0.75rem', color: '#4a6572', fontSize: '0.85rem', lineHeight: '1.5' }}>
            Tap <i className="fa-solid fa-arrow-up-from-bracket" style={{ color: '#2c5364' }}></i> <strong>Share</strong> then <strong>"Add to Home Screen"</strong> to install CareGuard as an app.
          </p>
          <button onClick={handleDismiss} style={{ width: '100%', padding: '0.5rem', borderRadius: '8px', border: '1px solid #e2e8f0', background: '#f8f9fa', cursor: 'pointer', color: '#6b8899', fontSize: '0.85rem' }}>
            Got it
          </button>
        </>
      ) : (
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button onClick={handleInstall} className="submit-button" style={{ flex: 1, padding: '0.5rem' }} data-testid="install-btn">
            <i className="fa-solid fa-download"></i> Install
          </button>
          <button onClick={handleDismiss} style={{ flex: 1, padding: '0.5rem', borderRadius: '8px', border: '1px solid #e2e8f0', background: '#fff', cursor: 'pointer', color: '#6b8899' }}>
            Not now
          </button>
        </div>
      )}
    </div>
  );
};

export default InstallPrompt;
